import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetCompanyWarehousesListQuery, } from "../../redux/api/chemicalization/companyWarehousesApi";
import { EntCompanyWarehouses } from "../../models/chemicalization/companyWarehouses";
import { EntCompanyWarehousesFilter } from "../../models/filters/companyWarehousesFilter";

interface IProps {
  value?: number | null;
  onChange?: (v: number) => void;
  companyId?: number | null;
}

const SelectCompanyWarehouses = (props: IProps) => {
  const { t } = useTranslation();
  const [ options, setOptions ] = useState<ISelectOption[]>([]);

  const [ getArchiveFolders ] = useLazyGetCompanyWarehousesListQuery();
  const {
	fetching,
	data,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntCompanyWarehouses, EntCompanyWarehousesFilter>({
	initialFilter: new EntCompanyWarehousesFilter(),
	query: getArchiveFolders
  });

  useEffect(() => {
	if (props.companyId) {
	  const filter = new EntCompanyWarehousesFilter();
	  filter.companyId = props.companyId;
	  setFilter(filter);
	  setData([]);
	  setCurrentPage(0);
	  setFetching(true);
	} else {
	  setOptions([]);
	  setData([]);
	}
  }, [props.companyId]);

  useEffect(() => {
	const options = Array.from(new Set(data)).map((a) => {
	  return { label: a.warehouseName ?? '', value: a.id ?? '' };
	});
	setOptions(options);
  }, [ data ]);

  const search = (value?: string) => {
	if (!value) return;
	const filter = new EntCompanyWarehousesFilter();
	filter.warehouseName = value;
	filter.companyId = props.companyId;
	setFilter(filter);
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const clear = () => {
	const filter = new EntCompanyWarehousesFilter();
	filter.warehouseName = null;
	filter.companyId = props.companyId;
	setFilter(filter);
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  return (
	<Select
	  placeholder={ t("msg.selectPlaceholder") }
	  onClear={ clear }
	  onSearch={ search }
	  onPopupScroll={ scrollHandler }
	  loading={ fetching }
	  value={ props.value }
	  onChange={ props.onChange }
	  options={ options }
	  filterOption={ defaultFilterOption }
	  showSearch
	  allowClear
	  dropdownRender={ (menu) => (
		<Spin spinning={ fetching }>
		  { menu }
		</Spin>
	  ) }
	/>
  );
};

export default SelectCompanyWarehouses;